import React, { Component } from 'react';

import commonUtil from './../../../../../../utils/commonUtil';
import InputButton from '../../../../../../components/ZUILib/InputButton';

const channel = commonUtil.getChannel();

class AddAditionalAddressButton extends Component {
  render() {
    const {addressesToAdd ,enableAddAddressButton,lables} = this.props; 
    const isDisable = addressesToAdd == "0" || enableAddAddressButton ;     
    const stylePrimaryButton = {
      gap: 10,
      display: 'flex',
      fontSize: '18px',
      padding: '10px 0',
      alignItems: 'center',
      justifyContent: 'center',            
    };
    let isSuspendedEvent = this.props?.eventStatusForSuspended;

     

    let agregarDirección = {
      id: 'eventAddAddressbtn',
      type: 'button',
      name: 'Agregar dirección',
      value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.add.address'),
      classname: (isDisable || isSuspendedEvent) ? 'eventAddAddressbtnDisabled'  :"eventAddAddressbtn",
      onClickHandler: () => {         
        this.props.addAddress();

      },
      autoFocus: false,
      ariaLabel: 'AddAddressbtndata',
      ariaHidden: false,
      beforeSvgIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill=${isDisable || isSuspendedEvent ? '#D8D8D8' : (this.props.selectedTheme?.color_500 || '#333333')}>
              <g clip-path="url(#clip0_12115_141358)">
                <path d="M15.8334 10.8337L10.8334 10.8337L10.8334 15.8337H9.16675L9.16675 10.8337H4.16675L4.16675 9.16699H9.16675V4.16699L10.8334 4.16699V9.16699L15.8334 9.16699V10.8337Z" fill=${this.props.selectedTheme?.color_500 || '#333333'}/>
              </g>
              <defs>
                <clipPath id="clip0_12115_141358">
                  <rect width="20" height="20" fill="white"/>
                </clipPath>
              </defs>
            </svg>`,
      disabled: isSuspendedEvent || isDisable,
      cssStyle: isDisable || isSuspendedEvent ? stylePrimaryButton : { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500,...stylePrimaryButton }
    };

    return (
      <div
        className="addAddressButtonIcon eventAddAddressbtnSticky"
        style={{
          minWidth: '236px',
          float: channel === 'web' ? 'right' : 0,
          marginTop: channel === 'web' ? 52 : 0,
        }}
      > <InputButton buttonAttr={agregarDirección} />
      </div>
    );
  }
}

export default AddAditionalAddressButton;
